






















































































import ContactLabelInterface from "@/interfaces/contactLabel.interface";
import i18n from "@/libs/i18n";
import { useContactsStore } from "@/store/useContactsStore";
import { styleByColor, textColorByBackgroundColor } from "@/utils/color";
import { RequestQueryBuilder } from "@rewiko/crud-request";
import { Label } from "@saysimple-platform/dtos";
import { computed, defineComponent, onMounted, Ref, ref, watch } from "@vue/composition-api";
import { useElementSize } from "@vueuse/core";
import {
    BBadge,
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BPopover,
    BSpinner,
} from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";
import { clone } from "lodash";

export default defineComponent({
    components: {
        BBadge,
        BButton,
        BCard,
        BCardText,
        BCardTitle,
        BPopover,
        BFormInput,
        BListGroup,
        BListGroupItem,
        BSpinner,
    },
    props: {
        contact: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const toast = useToast();

        const contactsStore = useContactsStore();
        // we clone it to no update a props by references
        const contactLocal = ref(clone(props.contact));

        const fetchContactLabels = () => {
            contactsStore
                .fetchContact(
                    RequestQueryBuilder.create({
                        fields: ["id"],
                        join: ["labels||id,name,color"],
                        filter: [{ field: "id", operator: "$eq", value: contactLocal.value.id }],
                    })
                )
                .then((result) => {
                    contactLabels.value = result.labels;
                });
        };

        watch(
            () => props.contact,
            (nvalue) => {
                // sometimes we got no id because of the parent
                if (nvalue.id != null && nvalue.id != contactLocal.value.id) {
                    contactLocal.value = clone(nvalue);
                    fetchContactLabels();
                }

                contactLocal.value = clone(nvalue);
            },
            { immediate: true }
        );

        const isCollapsed = ref(true);
        const searchText = ref("");
        const labelsElement: Ref<HTMLElement> = ref(null);
        const deletingLabels = ref<Record<number, boolean>>({});
        const addingLabels = ref<Record<number, boolean>>({});
        const contactLabels = ref([]);

        onMounted(() => {
            if (contactLocal.value.id != null) {
                fetchContactLabels();
            }
        });

        contactsStore.fetchLabels(
            RequestQueryBuilder.create({
                fields: ["id", "name", "color"],
            })
        );

        const selectableLabels = computed(() => {
            return contactsStore.labels.filter((labelData: ContactLabelInterface) => {
                return (
                    labelData.name?.toLowerCase().includes(searchText.value.toLowerCase()) &&
                    contactLabels.value.every((label) => label.id !== labelData.id)
                );
            });
        });

        const linkLabel = (label: Label) => {
            contactsStore
                .linkLabel(label, { id: contactLocal.value.id, labels: contactLabels.value })
                ?.then((result) => {
                    contactLabels.value = result.labels;
                    toast.success(i18n.t("entities.contact.labels.add.success"));
                })
                .catch(() => toast.error(i18n.t("entities.contact.labels.add.error")));
        };

        const unlinkLabel = (labelId: number) => {
            contactsStore
                .unlinkLabel(labelId, { id: contactLocal.value.id, labels: contactLabels.value })
                ?.then((result) => {
                    contactLabels.value = result.labels;
                    toast.success(i18n.t("entities.contact.labels.remove.success"));
                })
                .catch(() => toast.error(i18n.t("entities.contact.labels.remove.error")));
        };

        const { height: labelsElementHeight } = useElementSize(labelsElement);
        return {
            labelsElement,
            labelsElementHeight,
            contactsStore,
            selectableLabels,
            deletingLabels,
            addingLabels,
            searchText,
            linkLabel,
            unlinkLabel,
            isCollapsed,
            textColorByBackgroundColor,
            styleByColor,
            contactLocal,
            contactLabels,
        };
    },
});
